<template>
  <div class="itinerary-section-item-opening-hour-seasons">
    <section v-for="(season, sIdx) in seasons" :key="`oh-season-${sIdx}`" class="opening-hours-season">
      <header v-show="season.title">
        <h4 class="opening-hours-season__title">{{ season.title }}:</h4>
      </header>
      <ul class="opening-hours-season__items">
        <li v-for="(ohItem, ohIdx) in season.items" :key="`oh-season-${sIdx}-${ohIdx}`">
          <ItinerarySectionItemOpeningHourSeasonItem :item="ohItem" />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import ItinerarySectionItemOpeningHourSeasonItem from '@/components/itinerary/ItinerarySectionItemOpeningHourSeasonItem.vue';

export default {
  components: { ItinerarySectionItemOpeningHourSeasonItem },
  props: {
    seasons: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section-item-opening-hour-seasons {
  .opening-hours-season {
    &:not(:first-child) {
      margin-top: 8px;
    }

    &:not(:last-child) {
      padding-bottom: 8px;
      border-bottom: 1px solid vars.$c-gray-da;
    }

    &__title {
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;

      @media (min-width: vars.$mobile-break-point + 1px) {
        font-size: 16px;
      }
    }

    &__items {
      list-style-type: none;
      line-height: 1.5;
    }
  }
}
</style>
